import './vistas/css/App.css';

import {BrowserRouter as Router, Routes, Route} from 'react-router-dom';
import { useContext } from 'react';
import Inicio from './vistas/rutas/inicio';
import Yourny from './vistas/rutas/yourny';
import GyC from'./vistas/rutas/gruposycomunidades'
import SubirContenido from './vistas/rutas/subirpublicacion';
import ConfiguracionCuenta from './vistas/rutas/config_cuenta';
import ConfiguracionGrupo from './vistas/rutas/config_grupo';
import Mensajes from './vistas/rutas/mensajes';
import Registro from './vistas/rutas/registro';
import SobreNosotros from './vistas/rutas/sobreNosotros';
import TyC from './vistas/rutas/terminosCondiciones';
import Pruebas from './vistas/rutas/pruebas';
import Login from './vistas/rutas/login';
import Logout from './vistas/rutas/logout';
import Inventario from './vistas/rutas/inventario';
import RegistroCompleto from './vistas/rutas/registroCompleto';
import NotFound404 from './vistas/rutas/404';
import ContraCambiada from './vistas/rutas/contra_cambiada';
import Recuperar from './vistas/rutas/recuperar';
import GestionarIncidencia from './vistas/rutas/gestionar_Incicencia';
import CrearGrupo from './vistas/rutas/crear_grupo';

import VistaAdmin from './vistas/rutas/admin';
import { AuthContext } from './contexto/AuthContext';
import { ProtectedRoute } from './componentes/ProtectedRoute';

function App() {
  const { isLoading } = useContext(AuthContext);

  if (isLoading) {
    return <div className="App bg-dark text-white d-flex justify-content-center align-items-center" style={{height: '90vh'}}>
      <p>Verificando sesión...</p>
    </div>;
  }

  return (
    <Router>
      <Routes>
      <Route path='/' element={<Inicio/>}></Route>
      <Route path='/Yourny' element={<Yourny/>}></Route>
      <Route path='/GyC' element={<ProtectedRoute><GyC/></ProtectedRoute>}></Route>
      <Route path='/SubirPublicacion' element={<ProtectedRoute><SubirContenido/></ProtectedRoute>}></Route>
      <Route path='/ConfiguracionCuenta' element={<ProtectedRoute><ConfiguracionCuenta/></ProtectedRoute>}></Route>
      <Route path='/ConfiguracionGrupo/:id' element={<ProtectedRoute><ConfiguracionGrupo/></ProtectedRoute>}></Route>
      <Route path='/Mensajes' element={<ProtectedRoute><Mensajes/></ProtectedRoute>}></Route>
      <Route path='/Registro' element={<Registro/>}></Route>
      <Route path='/SobreNosotros' element={<SobreNosotros/>}></Route>
      <Route path='/TyC' element={<TyC/>}></Route>
      <Route path='/pruebas' element={<Pruebas/>}></Route>
      <Route path='/login' element={<Login/>}></Route>
      <Route path='/logout' element={<Logout/>}></Route>
      <Route path='/inventario' element={<ProtectedRoute><Inventario/></ProtectedRoute>}></Route>
      <Route path='/RegistroCompleto' element={<RegistroCompleto/>}></Route>
      <Route path='/CambioDeContraseña' element={<ContraCambiada/>}></Route>
      <Route path='/crearGrupo' element={<ProtectedRoute><CrearGrupo/></ProtectedRoute>}></Route>
      <Route path='/recuperar' element={<Recuperar/>}></Route>
      <Route path='/admin' element={<ProtectedRoute><VistaAdmin/></ProtectedRoute>}></Route>
      <Route path='/gestionar_incidencia/:id' element={<ProtectedRoute><GestionarIncidencia/></ProtectedRoute>}></Route>

      <Route path='*' element={<NotFound404/>}></Route>
      </Routes>
    </Router>
  );
}

export default App;
